const basePath: string = "https://jobbin-be-dev-d655f2bccfb7.herokuapp.com";

const isFormData = (body: unknown): body is FormData => {
    return body instanceof FormData;
};

const buildHeaders = (body?: unknown, headers: Record<string, string> = {}) => {
    if (isFormData(body)) {
        return { ...headers };
    }

    return { "Content-Type": "application/json", ...headers };
};

const serializeBody = (body?: unknown) => {
    if (body === undefined || body === null) {
        return undefined;
    }

    if (isFormData(body)) {
        return body;
    }

    if (typeof body === "string") {
        return body;
    }

    return JSON.stringify(body);
};

const LOGIN_PATH = "/";

/**
 * Un 401 pe un endpoint autentificat înseamnă token lipsă sau expirat: golim sesiunea
 * și trimitem userul la login, în loc să-l lăsăm pe o pagină care eșuează tăcut.
 *
 * Excepția sunt endpoint-urile `/auth/`, unde 401 înseamnă "email sau parolă incorecte" —
 * acolo un redirect ar reîncărca pagina de login exact înainte să apuce să afișeze eroarea.
 */
const handleUnauthorized = (response: Response, endpoint: string): Response => {
    if (response.status !== 401 || endpoint.includes("/auth/")) {
        return response;
    }

    localStorage.removeItem("jwtToken");
    if (window.location.pathname !== LOGIN_PATH) {
        window.location.assign(LOGIN_PATH);
    }
    return response;
};

const request = (endpoint: string, init: RequestInit): Promise<Response> =>
    fetch(`${basePath}/${endpoint}`, init).then((response) =>
        handleUnauthorized(response, endpoint)
    );

const api = {
    get: (endpoint: string, headers?: Record<string, string>) =>
        request(endpoint, {
            method: "GET",
            headers: { "Content-Type": "application/json", ...headers },
        }),

    post: (endpoint: string, body: unknown, headers?: Record<string, string>) =>
        request(endpoint, {
            method: "POST",
            body: serializeBody(body),
            headers: buildHeaders(body, headers),
        }),

    put: (endpoint: string, body: unknown, headers?: Record<string, string>) =>
        request(endpoint, {
            method: "PUT",
            body: serializeBody(body),
            headers: buildHeaders(body, headers),
        }),

    patch: (endpoint: string, body: unknown, headers?: Record<string, string>) =>
        request(endpoint, {
            method: "PATCH",
            body: serializeBody(body),
            headers: buildHeaders(body, headers),
        }),

    delete: (endpoint: string, headers?: Record<string, string>) =>
        request(endpoint, {
            method: "DELETE",
            headers: { "Content-Type": "application/json", ...headers },
        }),
};

export { api };